import React, { useEffect, useState, useRef } from 'react'
import Slider from "react-slick"
import findImageFormat from '../../../helpers/findImageFormat'
import { TagManager } from '../../../helpers/TagManager'
import FeaturedImagePlaceholder from './FeaturedImagePlaceholder'
import GalleryPopup from './GalleryPopup'
import Phyron from './Phyron'
import PhyronHelper, {PhyronSettings} from '../../../helpers/PhyronHelper'


const Gallery = ({media, car}) => {

  
  const [toggleFullscreen, setToggleFullscreen] = useState(false);

  const toggle = (e) => {
    e.preventDefault();
    setToggleFullscreen( !toggleFullscreen );
  }
  
  const mediaSlider = useRef()
  const thumbSlider = useRef()
  const mediaArray = findImageFormat(media, '1170x').map( item => item.src )
  const thumbsArray = findImageFormat(media, '225x150')
  const [loading, setLoading] = useState(true)
  const [hasPhyronVideo, setHasPhyronVideo] = useState(false)

  const settings = {
    dots: false,
    focusOnSelect: false,
    lazyLoad: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: thumbSlider.current,
    afterChange: (current) => {
      TagManager( { event: 'CarImageClick'})
    }
  }
  const thumbsSettings = {
    dots: false,
    lazyLoad: false,
    infinite: thumbsArray.length > 5 ? true:false,
    speed: 500,
    slidesToShow: thumbsArray.length > 5 ? 5:thumbsArray.length,
    slidesToScroll: 1,
    focusOnSelect: true,
    centerMode: false,
    asNavFor: mediaSlider.current,
    arrows: false,
    responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: thumbsArray.length > 3 ? 3:thumbsArray.length,
            slidesToScroll: 1
          }
        }
    ]
  }
  if (mediaArray.length < 2) {
    delete settings.asNavFor
  }

  useEffect(() => {
    // setLoading(true)
    const checkVideo = async () => {
      const exists = await PhyronHelper(car.registrationNumber)
      setHasPhyronVideo(exists)
      setLoading(false)
    }

    checkVideo()

  },[])

  return (
      <>

        { !loading && mediaArray.length > 0 ? // check has images
          <>
            <div className="gallery">
              <Slider ref={mediaSlider} {...settings}>
                {hasPhyronVideo && 
                  <div key={'gallery_phyron'} className="slide-wrapper">
                    <Phyron regnr={car.registrationNumber} />
                  </div>
                }
                { mediaArray.map((img,i)=>{
                  return (
                    <div key={'gallery_' + i } className="slide-wrapper">
                      <img className="slide-image" src={img} alt='' />
                    </div>
                  )
                })}
              </Slider>
            </div>
            <div className="thumb-controls">
              <div className="slide-control">
              { mediaArray.length >= 2 && 
                  <Slider ref={thumbSlider} {...thumbsSettings}>
                    {hasPhyronVideo && 
                      <div key={'gallery_phyron'} className="thumb-wrapper">
                        <img className="slide-image" width="225" src={`https://bilbolaget-nu.cust.se.phyron.com/repo/${car.registrationNumber}/${PhyronSettings.dimesions}-thumb-play.jpg`} alt='' />
                      </div>
                    }
                    { thumbsArray.map((img,i)=>{
                      return (
                        <div key={'gallery_' + i } className="thumb-wrapper">
                          <img className="slide-image" src={img.src} alt='' />
                        </div>
                      )
                    })}
                  </Slider>
              }
              </div>
              <a className="slick-fullscreen" href="#visa-fullskarm" title="Öppna fullskärm" onClick={ toggle }>Helskärm</a>
            </div>
            { toggleFullscreen && <GalleryPopup mediaArray={mediaArray} setToggleFullscreen={setToggleFullscreen} /> }
          </>
          : <FeaturedImagePlaceholder />
        } 

      </>
  )

};

export default Gallery